import apiClient from '../config/api';

const activityLogService = {
  /**
   * Paginated activity log with filters.
   * @param {Object} params - { module, action, userId, dateFrom, dateTo, page, pageSize }
   */
  getActivityLogs: async (params = {}) => {
    const response = await apiClient.get('/activity-log', { params });
    return response.data;
  },

  /**
   * Activity summary (counts per module) for the last N days.
   * @param {number} days - number of days to look back (default 7)
   */
  getActivitySummary: async (days = 7) => {
    const response = await apiClient.get('/activity-log/summary', { params: { days } });
    return response.data;
  },
};

export default activityLogService;
